export const HUBSPOT_INTEGRATION = 'hubspot'
export const PIPEDRIVE_INTEGRATION = 'pipedrive'
export const ZOHO_INTEGRATION = 'zoho'
export const SALESFORCE_INTEGRATION = 'salesforce'
export const GUESTY_INTEGRATION = 'guesty'
